import { Truck } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';
import { Alert, AlertDescription } from '@/components/ui/alert';

interface ShippingTermsSelectorProps {
  value: 'fob_origin' | 'fob_destination' | null;
  onChange: (value: 'fob_origin' | 'fob_destination') => void;
  readOnly?: boolean;
}

export function ShippingTermsSelector({ value, onChange, readOnly = false }: ShippingTermsSelectorProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Truck className="h-5 w-5" />
          Shipping Terms
          {!readOnly && !value && <Badge variant="destructive">Required</Badge>}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {readOnly ? (
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <Badge variant="secondary" className="text-base px-3 py-1">
                {value === 'fob_origin' ? 'FOB Origin' : 'FOB Destination'}
              </Badge>
            </div>
            
            {value === 'fob_origin' && (
              <Alert>
                <AlertDescription>
                  <strong>FOB Origin:</strong> The buyer takes ownership and responsibility for the goods once they leave the seller's location. The buyer is responsible for shipping costs, insurance, and any risk of loss or damage during transit.
                </AlertDescription>
              </Alert>
            )}
            
            {value === 'fob_destination' && (
              <Alert>
                <AlertDescription>
                  <strong>FOB Destination:</strong> The seller retains ownership and responsibility for the goods until they reach the buyer's location. The seller is responsible for shipping costs, insurance, and any risk of loss or damage during transit.
                </AlertDescription>
              </Alert>
            )}
          </div>
        ) : (
          <>
            <RadioGroup value={value || ''} onValueChange={(val) => onChange(val as 'fob_origin' | 'fob_destination')}>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="fob_origin" id="fob_origin" />
                <Label htmlFor="fob_origin" className="cursor-pointer">FOB Origin</Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="fob_destination" id="fob_destination" />
                <Label htmlFor="fob_destination" className="cursor-pointer">FOB Destination</Label>
              </div>
            </RadioGroup>
            
            {value === 'fob_origin' && (
              <Alert>
                <AlertDescription>
                  <strong>FOB Origin:</strong> The buyer takes ownership and responsibility for the goods once they leave the seller's location. The buyer is responsible for shipping costs, insurance, and any risk of loss or damage during transit.
                </AlertDescription>
              </Alert>
            )}
            
            {value === 'fob_destination' && (
              <Alert>
                <AlertDescription>
                  <strong>FOB Destination:</strong> The seller retains ownership and responsibility for the goods until they reach the buyer's location. The seller is responsible for shipping costs, insurance, and any risk of loss or damage during transit.
                </AlertDescription>
              </Alert>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
}
